import { render, staticRenderFns } from "./whotherDialog.vue?vue&type=template&id=0cfbb6a4"
import script from "./whotherDialog.vue?vue&type=script&lang=js"
export * from "./whotherDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports